import qs from 'query-string';
import mapValues from 'lodash/mapValues';
import each from 'lodash/each';

const getAllIndexes = (arr: string, val: string) => {
  const indexes = [];
  let i = -1;
  while ((i = arr.indexOf(val, i + 1)) != -1) {
    indexes.push(i);
  }
  return indexes;
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const loadDataUrlParser = (commandUrl: string, item: any) => {
  const colonIndex = commandUrl?.indexOf(':') || 0;
  if (colonIndex === -1) {
    return commandUrl;
  }

  const allColons = getAllIndexes(commandUrl, ':');

  const paramsList: string[] = [];
  allColons.forEach((colon) => {
    // znajdź najbliższy separator po ':' (może to być '/', '&', '?', '#')
    const separators = ['/', '&', '?', '#'];
    const indexes = separators.map((s) => commandUrl.indexOf(s, colon)).filter((i) => i !== -1);

    const nextIndex = indexes.length ? Math.min(...indexes) : -1;
    const param = nextIndex !== -1 ? commandUrl.slice(colon, nextIndex) : commandUrl.slice(colon);
    paramsList.push(param);
  });

  let endpointUrl = commandUrl;

  paramsList.forEach((param) => {
    const newValue = item[param.replace(':', '')];

    endpointUrl = endpointUrl.replace(param, typeof newValue === 'undefined' ? null : newValue);
  });

  return endpointUrl;
};

type IParamsList = { mode?: string; [key: string]: any };

export const paramsToUrlParser = (params: string, data: any) => {
  // lista parametrów
  const { mode, ...restParams }: IParamsList = qs.parse(params.replaceAll(';', '&') || '');

  // parsowanie parametrów do obiektu
  const paramsObject = mapValues(restParams, (param: string, key: string) => {
    if (param?.[0] === ':') {
      const paramKey = param.replace(':', '');

      return data[paramKey];
    }
    return data[key];
  });

  // parsowanie parametrów do urla
  return qs.stringify({ ...paramsObject, mode });
};

export const paramsListToRequestParser = (paramsList: string, requestState: any) => {
  const params = paramsList.split(';');
  let req = {};
  each(requestState, (o) => (req = { ...req, ...o }));
  const request = params?.reduce((acc, curr) => {
    // sprawdź czy parametr zawiera znak '=' (format: "key=value" lub "key=:sourceKey")
    if (curr.includes('=')) {
      const [targetKey, value] = curr.split('=');
      // jeśli wartość zaczyna się od ':', traktuj ją jako klucz źródłowy
      if (value?.startsWith(':')) {
        const sourceKey = value.replace(':', '');
        // pobierz wartość z sourceKey i przypisz do targetKey
        (acc as any)[targetKey] = (req as any)[sourceKey];
      } else {
        // w przeciwnym razie traktuj jako wartość literału
        (acc as any)[targetKey] = value;
      }
    } else if (curr.includes(':')) {
      // format bez '=' (np. "parent_category_id:param_category_id")
      const [targetKey, sourceKey] = curr.split(':');
      // pobierz wartość z sourceKey i przypisz do targetKey
      (acc as any)[targetKey] = (req as any)[sourceKey];
    } else {
      // standardowe przypisanie (tylko nazwa klucza)
      (acc as any)[curr] = (req as any)[curr];
    }
    return acc;
  }, {});

  return request;
};

export const paramsListToPageUrlParser = (pageUrl: string, paramsList: string, data: any) => {
  const paramsListFormatted = qs.parse(paramsList.replaceAll(';', '&') || '');

  const paramsListObject = mapValues(paramsListFormatted, (value) => {
    if (typeof value === 'string' && value[0] === ':') {
      const key = value.replaceAll(':', '');

      return data[key];
    }

    return value;
  });

  return pageUrl + `?${qs.stringify(paramsListObject)}`;
};
